"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _autobahnUtilities = require("@gcc/autobahn-utilities");

var _propTypes = require("prop-types");

var _react = _interopRequireWildcard(require("react"));

var _Modal = _interopRequireWildcard(require("../Modal/Modal.index"));

var _BrightcovePlayer = _interopRequireDefault(require("./BrightcovePlayer.player"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/* eslint-disable no-console */
var BrightCovePlayerModal = function BrightCovePlayerModal(_ref) {
  var height = _ref.height,
      theme = _ref.theme,
      width = _ref.width,
      baseApiUrl = _ref.baseApiUrl,
      videoName = _ref.videoName;

  var _useState = (0, _react.useState)(''),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      videoId = _useState2[0],
      setVideoId = _useState2[1];

  var _useState3 = (0, _react.useState)(''),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      videoDescription = _useState4[0],
      setVideoDescription = _useState4[1];

  var _useModal = (0, _Modal.useModal)({
    isLoading: true,
    isOpen: true
  }),
      isLoading = _useModal.isLoading,
      isOpen = _useModal.isOpen,
      setIsLoading = _useModal.setIsLoading,
      toggle = _useModal.toggle;

  (0, _react.useEffect)(function () {
    var bc = new _autobahnUtilities.Brightcove(baseApiUrl);
    bc.getVideo(videoName).then(function (video) {
      var id = video.id,
          description = video.description;
      setVideoId(id);
      setVideoDescription(description);
    })["catch"](function (e) {
      return console.log("error getting brightcove video info. videoName=\"".concat(videoName, "\" error=\"").concat(e, "\""));
    })["finally"](setIsLoading(false));
  }, [setIsLoading, videoName, baseApiUrl]);
  return /*#__PURE__*/_react["default"].createElement(_Modal["default"], {
    height: height,
    hide: toggle,
    isLoading: isLoading,
    isOpen: isOpen,
    theme: theme,
    width: width
  }, /*#__PURE__*/_react["default"].createElement("p", null, /*#__PURE__*/_react["default"].createElement("b", null, videoDescription)), /*#__PURE__*/_react["default"].createElement(_BrightcovePlayer["default"], {
    videoId: videoId
  }));
};

BrightCovePlayerModal.defaultProps = {
  theme: {},
  baseApiUrl: '',
  height: 450,
  width: 600
};
BrightCovePlayerModal.propTypes = {
  height: _propTypes.number,
  theme: (0, _propTypes.shape)({}),
  width: _propTypes.number,
  baseApiUrl: _propTypes.string,
  videoName: _propTypes.string.isRequired
};
BrightCovePlayerModal.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "BrightCovePlayerModal",
  "props": {
    "theme": {
      "defaultValue": {
        "value": "{}",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "shape",
        "value": {}
      },
      "required": false
    },
    "baseApiUrl": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "height": {
      "defaultValue": {
        "value": "450",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "number"
      },
      "required": false
    },
    "width": {
      "defaultValue": {
        "value": "600",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "number"
      },
      "required": false
    },
    "videoName": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": true
    }
  }
};
var _default = BrightCovePlayerModal;
exports["default"] = _default;